import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import renderDust from './Dust';

const PathContentStep = ({ id, progress, stepNumber, inner, collapsed }) => {
  const completed = progress.completedDate;
  return (
    <div
      id={`step-${id}`}
      className={classNames('PathContentStep', {
        'PathContentStep--innerStep': inner,
        'PathContentStep--collapsed': collapsed,
        'PathContentStep--completed': completed,
      })}
    >
      {completed && (
        <Icon className="PathContentStep-icon" name="correct" key="1" />
      )}
      {completed && renderDust()}
      {!completed && (
        <span className="PathContentStep-position">{stepNumber}</span>
      )}
    </div>
  );
};

export default PathContentStep;
